import * as React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { dispatchTrackErrorEvent } from '@grandvisionhq/svc-tealium/events';
import { useAlgoliaConfig } from '../AlgoliaConfig.js';
import { useAlgoliaIndex } from './use-algolia-index.js';

function useAlgoliaData() {
    var ref9, ref1, ref2, ref3, ref4, ref5;
    const { priceSegmentCookie  } = useAlgoliaConfig();
    const { results: { hits , query , nbHits , renderingContent  } , indexUiState , uiState , status , setIndexUiState ,  } = useInstantSearch();
    if (status === 'error') {
        dispatchTrackErrorEvent(()=>Promise.resolve({
                Error_Source: 'Server',
                Error_Code: 'Search',
                Error_Details: 'Unable to search for products',
                Error_Message: ''
            })
        );
    }
    var ref6;
    const productType = (ref6 = (ref9 = indexUiState.refinementList) === null || ref9 === void 0 ? void 0 : (ref1 = ref9['filterableAttributes.productType']) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref6 !== void 0 ? ref6 : (ref2 = indexUiState.refinementList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.productType) === null || ref3 === void 0 ? void 0 : ref3[0];
    // TODO: on search page, we are not using the new product index so for now, when searching,
    // we return undefined for product type so our mapper works. this can be fixed in CXCD-10248
    const mappedResults = useAlgoliaIndex(hits, query.length > 0 ? undefined : productType, priceSegmentCookie);
    var ref7;
    const value = React.useMemo(()=>{
        var ref, ref8;
        return {
            allSearchResults: uiState,
            facetOrder: (ref7 = renderingContent === null || renderingContent === void 0 ? void 0 : (ref = renderingContent.facetOrdering) === null || ref === void 0 ? void 0 : (ref8 = ref.facets) === null || ref8 === void 0 ? void 0 : ref8.order) !== null && ref7 !== void 0 ? ref7 : [],
            mappedResults,
            searchQuery: query,
            searchState: indexUiState,
            total: nbHits,
            isLoading: status === 'loading',
            setIndexUiState
        };
    }, [
        indexUiState,
        mappedResults,
        nbHits,
        query,
        renderingContent === null || renderingContent === void 0 ? void 0 : (ref4 = renderingContent.facetOrdering) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.facets) === null || ref5 === void 0 ? void 0 : ref5.order,
        setIndexUiState,
        status,
        uiState, 
    ]);
    return value;
}

export { useAlgoliaData };
//# sourceMappingURL=use-algolia-data.js.map
